import React from 'react'

const NewScript = () => (
  <svg width="10" height="10" viewBox="0 0 10 10" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path fillRule="evenodd" clipRule="evenodd" d="M4.44453 4.44453V0H5.55547V4.44453H10V5.55547H5.55547V10H4.44453V5.55547H0V4.44453H4.44453Z" fill="currentColor"/>
  </svg>
)
export default NewScript;
